import * as React from "react";
import type { SVGProps } from "react";
const ExcitedFaceSvg = (props: SVGProps<SVGSVGElement>) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_799_4162)">
            <path d="M9.07696 5.61486C8.94951 5.61486 8.84619 5.51154 8.84619 5.38409C8.84619 5.25664 8.94951 5.15332 9.07696 5.15332" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.07715 5.61486C9.2046 5.61486 9.30792 5.51154 9.30792 5.38409C9.30792 5.25664 9.2046 5.15332 9.07715 5.15332" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.92315 5.61486C4.7957 5.61486 4.69238 5.51154 4.69238 5.38409C4.69238 5.25664 4.7957 5.15332 4.92315 5.15332" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.92285 5.61486C5.0503 5.61486 5.15362 5.51154 5.15362 5.38409C5.15362 5.25664 5.0503 5.15332 4.92285 5.15332" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 13C10.3138 13 13 10.3138 13 7C13 3.68629 10.3138 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3138 3.68629 13 7 13Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.00644 9.98008C5.35185 10.3325 6.13432 10.5276 6.90217 10.4853C7.67001 10.4431 8.47119 10.1608 8.84568 9.7687" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_799_4162">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>


);
export default ExcitedFaceSvg;
